<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header pt-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-0 mb-sm-0">
        <span class="text-uppercase page-subtitle">Zamówienia</span>
        <h3 class="page-title">Lista zamówień wewnętrznych</h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="light"
          class="text-nowrap-dashboard"
          @click.prevent="getCurrentDate">
          <i class="material-icons">double_arrow</i>
          Wróć do aktualnego tygodnia
        </d-button>
      </d-col>
    </d-row>
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center order__date_top text-sm-left mb-4 mb-sm-0 align-items-center">
        <d-button
          class="order__date_top_button"
          @click.prevent="dateDown"
          theme="light">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">
            keyboard_arrow_left
          </i>
        </d-button>
        <p
          class="order__date_top_text"
          :class="{'order__date_top_text_active' : current_week === 0}">
          {{ week_dates[0] }} <span class="text-primary ml-2 mr-2"> &ndash; </span> {{ week_dates[6] }}
        </p>
        <d-button
          class="order__date_top_button"
          @click.prevent="dateUp"
          theme="light">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">keyboard_arrow_right</i>
        </d-button>
      </d-col>
    </d-row>
    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="orders-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <validation-provider
          class="w-100"
          style="margin-left: -10px;margin-right: 10px;"
          :rules="'required'"
          name="customer_id"
          v-slot="{ errors }">
          <v-select
            id="customer-id-select"
            class="ml-2 w-100"
            :options="customers"
            :reduce="customer => customer.id"
            v-model="filters.customer_id"
            placeholder="Wybierz klienta*"
            :state="errors.length ? 'invalid' : null"
            :searchable="false"
            label="name">
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name ? option.name : '' }}
              </div>
            </template>
            <template
              slot="selected-option"
              slot-scope="option">
              <div class="selected d-center">
                {{ option.name ? option.name : '' }}
              </div>
            </template>
          </v-select>
          <div
            class="invalid-feedback pl-2"
            style="position: absolute;z-index: 2;margin-top: -1px;">
            {{ errors[0] }}
          </div>
        </validation-provider>
        <v-select
          v-if="filters.customer_id"
          class="ml-2 w-100"
          :options="shops"
          :reduce="shop => shop.id"
          v-model="filters.shop_id"
          placeholder="Wybierz placówkę"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          class="ml-2 w-100"
          :options="products"
          :reduce="product => product.id"
          v-model="filters.product_id"
          placeholder="Wybierz produkt"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}<template v-if="option.show_in_form === 0"> (nie w formularzu klienta)</template>
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table
        class="table mt-0 mb-0 full-width"
        style="table-layout: fixed;">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Produkt</th>
            <th
              scope="col"
              class="border-0 text-center"
              v-for="(day, index) of week_day_names"
              :key="day + index">{{ day }}<br />{{ week_dates[index] }}</th>
            <th
              scope="col"
              class="border-0">Suma</th>
          </tr>
        </thead>
        <tbody v-if="loaded && orders && week_dates.length > 0">
          <tr
            v-for="(order, index) of orders"
            :key="'order-' + index">
            <td>
              {{ order.product_name }}
            </td>
            <td
              v-for="day of week_dates"
              :key="day + '-' + index">
              <template v-if="order[day]">
                <p
                  class="mb-1 mt-0 border-dark"
                  :class="{ 'border-bottom' : i < order[day].length - 1 }"
                  v-for="(single_order, i) of order[day]"
                  :key="day + '-' + i + '-' + single_order.product_id + '-' + index">
                  <a
                    href="#"
                    @click.prevent="showOrderModal(single_order)"
                    class="mr-1">{{ single_order.order_id }}</a>
                  <span class="text-info"><span
                    class="material-icons"
                  style="font-size: 12px;">store</span> {{ single_order.shop_name }}</span><br />{{ orderWeight(single_order) }} {{ units[single_order.product_unit] }}
                  <a
                    @click.prevent=""
                    title="Produkt nie został jeszcze zważony"
                    class="material-icons text-danger small"
                    style="font-size: 18px;vertical-align: middle;"
                    v-if="single_order.weighing_required === 1 && single_order.weight <= 0">
                    production_quantity_limits
                  </a>
                </p>
              </template>
            </td>
            <td>
              {{ orderSum(order).weight }} kg<br />
              {{ parseInt(orderSum(order).piece) }} sztuk
            </td>
          </tr>
          <tr v-if="orders.length === 0">
            <td
              colspan="9"
              class="text-center">
              Brak zamówień do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

    </d-card>
    <order-modal
      v-if="order.order_id"
      :close-modal="closeOrderModal"
      :order-id="order.order_id"
      :show-modal.sync="show_order_modal"
      :customer-id="filters.customer_id" />
    <d-popover
      target="#customer-id-select"
      v-if="!filters.customer_id"
      :show="!filters.customer_id"
      placement="top"
      container=".shards-demo--example--popover-01">
      <p class="m-0 text-info"><strong>Wybierz klienta</strong></p>
    </d-popover>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import ListUtils from '../../utils/ListUtils.js';
import OrderModal from '@/components/forms/orders/OrderModal';

const moment = require('moment');

export default {
  name: 'orders',
  mixins: [
    HasFilters,
  ],
  components: {
    OrderModal
  },
  data () {
    return {
      customers: [],
      orders: [],
      products: [],
      current_week: 0,
      shops: [],
      week_dates: [],
      loaded: false,
      load_error: false,
      order: {},
      show_order_modaL: false,
      order_modal_data: {},
      week_day_names: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      units: {
        KILOGRAM: 'kg',
        PIECE: 'szt'
      },
      filters: {
        customer_id: '',
        shop_id: '',
        product_id: '',
        delivery_date_from: '',
        delivery_date_to: '',
      }
    };
  },
  watch: {
    startDate () {
      this.loadFilteredData();
    },
    'filters.customer_id': function (value) {
      if (value) {
        this.filters.shop_id = '';
        this.loadShops();
      }
    }
  },
  mounted () {
    this.loadCustomers();
    this.getWeekDays();
    this.loadProducts();
    if (this.filters.customer_id) {
      this.loadShops();
      this.loadFilteredData();
    }
  },
  methods: {
    showOrderModal (order) {
      this.order = order;
      this.order_modal_data = order;
      this.show_order_modal = true;
      this.$forceUpdate();
    },
    closeOrderModal () {
      this.show_order_modal = false;
      this.$forceUpdate();
    },
    loadFilteredData () {
      this.supplies_check = false;
      let where = {
        product_id: this.filters.product_id ? this.filters.product_id : '',
        shop_id: this.filters.shop_id ? this.filters.shop_id : '',
        customer_id: this.filters.customer_id ? this.filters.customer_id : '',
        delivery_date_from: this.filters.delivery_date_from ? this.filters.delivery_date_from : '',
        delivery_date_to: this.filters.delivery_date_to ? this.filters.delivery_date_to : '',
      };
      this.$http.post('/orders/summary', {
        pagination: false,
        where
      }).then(response => {
        this.orders = [];
        const orders = [];
        Object.entries(response.data.items).forEach(([key, value]) => {
          value.products.forEach((product) => {
            if (!orders[product.product_id.toString()]) {
              orders[product.product_id.toString()] = {
                product_name: product.product_name
              };
            }
            if (!orders[product.product_id.toString()][key]) {
              orders[product.product_id.toString()][key] = [];
            }
            orders[product.product_id.toString()][key].push(product);
          });
        });
        Object.entries(orders).forEach(([key, value]) => {
          if (key) {
            this.orders.push(value);
          }
        });
        this.$forceUpdate();
      }).catch(error => {
        console.error(error);
      });
    },
    getWeekDays () {
      const week = this.current_week;
      if (week >= 0) {
        for (let i = 0; i < this.week_day_names.length; i++) {
          this.week_dates[i] = moment().startOf('week').add((i + 1) + (week * 7), 'days').format('YYYY-MM-DD');
        }
      } else {
        for (let i = 0; i < this.week_day_names.length; i++) {
          this.week_dates[6 - i] = moment().startOf('week').subtract(i - ((week + 1) * 7), 'days').format('YYYY-MM-DD');
        }
      }

      this.filters.delivery_date_from = this.week_dates[0];
      this.filters.delivery_date_to = this.week_dates[6];
    },
    orderWeight (order) {
      let weight = 0;
      if (!order.weight || order.weight <= 0) {
        if (order.weighing_required === 0) {
          weight = Number(order.quantity).toFixed(2);
        } else if (order.product_unit === 'PIECE') {
          weight = Number(order.quantity).toFixed(2);
        } else if (order.average_weight > 0) {
          weight = Number(parseFloat(order.average_weight) * Number(order.quantity)).toFixed(2);
        }
      } else {
        weight = Number(order.weight).toFixed(2);
      }
      if (order.product_unit !== 'KILOGRAM') {
        weight = Number(weight).toFixed(0);
      }
      return weight;
    },
    orderSum (order) {
      let sumWeight = 0.00;
      let sumPiece = 0.00;
      Object.entries(order).forEach(([key, value]) => {
        if (key !== 'product_name') {
          [...value].forEach((val) => {
            if (val.product_unit === 'KILOGRAM') {
              sumWeight += parseFloat(this.orderWeight(val));
            } else {
              sumPiece += Number(this.orderWeight(val));
            }
          });
        }
      });
      return {
        weight: Number(sumWeight).toFixed(2),
        piece: Number(sumPiece)
      };
    },
    dateUp () {
      this.current_week = this.current_week + 1;
      this.getWeekDays();
      this.loadFilteredData();
    },
    dateDown () {
      this.current_week = this.current_week - 1;
      this.getWeekDays();
      this.loadFilteredData();
    },
    getCurrentDate () {
      this.current_week = 0;
      this.getWeekDays();
      this.loadFilteredData();
    },
    loadProducts () {
      ListUtils.loadItemsData(this, {
        endpoint: '/products/items',
        listField: 'products',
        pagination: false,
      });
    },
    loadShops () {
      let where = {
        customer_id: Number(this.filters.customer_id)
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/shops/items',
        params: {
          pagination: false,
          where
        },
        outputKey: 'shops',
      });
    },
    loadCustomers () {
      this.$http.post('/customers/items', {
        pagination: false,
        where: {
          is_internal: 1
        }
      }).then(response => {
        this.customers = response.data.data;
      }).catch(error => {
        console.error(error);
      });
    },
    clearFilters () {
      this.filters.product_id = '';
      this.filters.customer_id = '';
      this.filters.shop_id = '';
      this.orders = [];
    },
    validateFiltersForm () {
      FormUtils.validate(this.$refs['orders-filters-form'], this.debouncedLoadFilteredData);
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/order-list';
</style>

